import { useRouteMatch } from 'react-router-dom';

export const createUseParams =
  <TParams>() =>
  () =>
    useRouteMatch<TParams>().params;
